import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/Pages/Admin/Store/index';
// import { trekService } from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import { SeasonModel } from '@/Pages/Admin/Modules/Models/Master/SeasonModel';
import { hotelService } from '@/Pages/Admin/Modules/Hotel/Services/HotelService';


@Module({ name: 'General', namespaced: true, dynamic: true, store })
class General extends VuexModule {
  public GeneralTabBasic: any = [];
  // public Seasons: SeasonModel = new SeasonModel([{}]);
  // public DestinationList: any = [];


  @Mutation
  public GET_GENERAL_TAB_BASIC_DATA(data: any) {
    // console.log("Data from Mutation", data.data.data);
    this.GeneralTabBasic = data.data.data;
  }

  @Action
  public async GetHotelTitle(payLoad: object): Promise<any> {
    return await new Promise((resolve, reject) => {
      hotelService
        .getGeneralTabData(payLoad)
        .then((res: any) => {
          this.context.commit('GET_GENERAL_TAB_BASIC_DATA', res);
          // console.log("from store action" ,res.data.data);
          resolve(res);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  @Mutation
  public SET_GENERAL_TAB_BASIC_DATA(data: any) {
    // console.log("Data from Mutation", data.data.data);
    this.GeneralTabBasic = data;
  }

  @Action
  public async setHotelTitle(payLoad: object): Promise<any> {
    this.context.commit('SET_GENERAL_TAB_BASIC_DATA', payLoad);
  }
  @Mutation
  public POST_GENERAL_TAB_BASIC_DATA(data: any) {
    // console.log("Data from Mutation", data.data.data);
    this.GeneralTabBasic = data;
  }

  // @Action
  // public async UpdateHotelTitle(payLoad: object): Promise<any> {
  //   return await new Promise((resolve, reject) => {
  //         this.context.commit('POST_GENERAL_TAB_BASIC_DATA', payLoad);
  //         // console.log("from store action" ,res.data.data);
  //   });
  // }


  // @Action
  // public async GetCityList(): Promise<any> {
  //   return await new Promise((resolve, reject) => {
  //     trekService
  //       .getTourTypeList()
  //       .then((res: any) => {
  //         this.context.commit('GET_TOUR_TYPE_LIST', res);
  //         // console.log("from store action" ,res.data.data);
  //         resolve(res);
  //       })
  //       .catch((error: any) => {
  //         reject(error);
  //       });
  //   });
  // }

}

export default getModule(General);
